import styled, { createGlobalStyle } from 'styled-components';
import {
  Checkbox,
  Modal,
  ModalContent,
  Space,
  Button,
} from '@cashfree-intl/coherent';

// Types
import { StyledCheckboxProps } from './types';

export const StyledCheckbox = styled(Checkbox)<StyledCheckboxProps>`
  min-height: ${props => props.$minHeight} !important;
  margin-bottom: ${props => props.$marginBottom};
  margin-top: ${props => props.$marginTop};
`;

export const StyledDivider = styled.div`
  height: 1px;
  background: var(--DISABLED);
`;

const getFullScreenModalStylesByProps = ({ whiteHeader, theme }) => {
  switch (true) {
    case whiteHeader:
      return `
        background-color: ${theme.COLORS.white};
        border-bottom: 1px solid ${theme.COLORS.bg};
      `;
    default:
      return ``;
  }
};

export const FullScreenModal = styled(Modal)`
  &.ui.modal {
    margin: -1em !important;
    width: 100%;
    height: 100%;
    border-radius: 0;
    display: flex !important;
    flex-direction: column;

    .header {
      border-radius: 0;
      height: 5.375rem;
      ${getFullScreenModalStylesByProps}
    }

    .cross {
      top: 2.25rem !important;
    }

    & > .icon:first-child + *,
    & > :first-child:not(.icon) {
      border-radius: 0;
      border-bottom: 0;
    }
  }
`;

export const FullScreenModalContent = styled(ModalContent)`
  display: flex !important;
  flex-direction: column;
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
`;

export const StyledContent = styled(Space)`
  height: 100%;
  overflow: hidden;
`;

export const StyledWizard = styled.div`
  flex: 0 0 20%;
  padding: 0 0 0 1.25rem;
`;

export const FullScreenFormWrapper = styled(Space)`
  flex: 1;
  height: 100%;
  width: 100%;
  background: var(--BACKGROUND_LIGHT);
  padding: 1.5rem;
  overflow: auto !important;

  &::-webkit-scrollbar {
    width: ${props => props.theme.SCROLL_BAR_WIDTH.small};
  }
`;

export const FullScreenModalFooter = styled(Space)`
  height: 4.5rem;
  width: 100%;
  box-shadow: 0px -4px 4px 0px rgba(19, 9, 81, 0.11);
  padding: 1rem 2rem;
  background: ${props => props.theme.COLORS.white};
`;

export const FullScreenForm = styled(Space)`
  flex-grow: 1;
  width: 100%;
`;

export const StyledTableOnHover = styled.table`
  width: 100%;
  tr {
    &:hover {
      .open-link-cta {
        visibility: unset;
      }
    }
  }
`;

export const PageText = styled.div`
  color: ${props => props.theme.COLORS.body};
  margin-bottom: 1.5rem;
`;

export const StyledButtonLink = styled(Button)`
  border: none;
  padding: 0;
  width: fit-content;
  text-align: left;
  &:hover {
    background-color: ${props => props.theme.COLORS.white};
  }
`;

export const ConfigurationsGlobalStyle = createGlobalStyle`
  .ui.dimmer {
    z-index: 1000000 !important;
  }

  .Toastify__toast-container {
    z-index: 10000000 !important; 
  }
  
  .ui.popup{
    z-index: 10000000 !important; 
  }
`;
